export default "__VITE_PUBLIC_ASSET__cceabfde__"